<!-- Only show pencil icon button in edit mode (bundle detail page) -->
<!-- In create mode, the empty state button is used to open the modal -->
@if (mode() === 'edit') {
  <se-fe-modal-button
    #openModalBtn
    [seFeDataButton]="{icon: true, buttonType: 'button'}"
    (seFeButtonAction)="onOpenModal($event)">
    <se-fe-icon
      seFeModalIcon
      seFeDataName="pencil_fill"
      seFeDataSize="500"
      seFeDataColor="default"
      seFeDataAriaLabel="edit"></se-fe-icon>
  </se-fe-modal-button>
}

<se-fe-modal
  seFeDataSize="large"
  #chooseBundleProducts
  (seFeClose)="modalClosed()"
  class="choose-bundle-products-modal">
  <div seFeModalHeader>
    <se-fe-modal-header seFeDataTitle="Choose products in bundle"></se-fe-modal-header>
  </div>

  <se-fe-modal-content>
    <product-selection-table
      [products]="(products$ | async) ?? []"
      [loading]="loading$ | async"
      [paginationOptions]="(paginationOptions$ | async) ?? undefined"
      [query]="queryString"
      [selectedProductIds]="selectedProductIds"
      [paginationEnabled]="true"
      [showSearch]="true"
      (queryChanged)="queryChanged($event)"
      (selectionChanged)="onSelectionChange($event)"></product-selection-table>
    @if (mode() === 'edit') {
      <form [noValidate]="true" [formGroup]="bundlePriceForm">
        <se-fe-form-field [seFeDataConfig]="bundlePriceConfig">
          <se-fe-form-field-text #bundlePrice formControlName="price">
            <span seFeFormFieldTextBefore>$</span>
          </se-fe-form-field-text>
        </se-fe-form-field>
      </form>
    }
  </se-fe-modal-content>

  <div seFeModalFooter>
    <div class="se-fe-footer">
      <div class="se-fe-footer__container">
        @if (selectedProducts.length > 0) {
          <div class="products-selected-text">{{ selectedProducts.length }} selected</div>
        }
        <se-fe-button seFeDataEmphasis="low" (click)="chooseBundleProducts.close()">Cancel</se-fe-button>
        <se-fe-button seFeDataEmphasis="high" (click)="handleAction()">Save</se-fe-button>
      </div>
    </div>
  </div>
</se-fe-modal>
